import { generateRouteVariants } from './url_helper'

// Routes where footer/nav tabs should be visible (topic listing pages)
export const FOOTER_VISIBLE_PATHS = ['/stories', '/temple', '/groups', '/feed', '/activities', '/more']

export const isFooterVisiblePath = (pathname) => FOOTER_VISIBLE_PATHS.includes(pathname)

const activityGroupIdRouteFragment = '/:activityGroupId'
const subActivityGroupIdRouteFragment = `${activityGroupIdRouteFragment}/activities/:subActivityGroupId`

export const activityGroupAllowedRoutes = generateRouteVariants(
  ['/stories', '/story', '/temple', '/share'],
  activityGroupIdRouteFragment
)
export const subActivityGroupAllowedRoutes = generateRouteVariants(
  ['/stories', '/story', '/temple', '/share'],
  subActivityGroupIdRouteFragment
)
